<template>
  <div class='compliance-assets-container'>
    <div class="compliance-assets-text">
      {{ getAssets }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'AssetsTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getAssets() {
      return this.item.assets;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';
.compliance-assets-container {
  .compliance-assets-text{
    text-transform: capitalize;
    color: var(--text-primary);
    font-size: rem(14);
    font-family: $font-family-semibold;
    line-height: 1.2em;
    display: flex;
    align-items: center;
    width: rem(70);
    height: rem(25);
    justify-content: center;
    margin-top: rem(12);
    background-color: var(--bg-tertiary);
    border-radius: $radius-md;
  }
}
</style>
